import { Service, ServiceCategory } from "../types";

const colorServices: Service[] = [
  {
    id: 'color',
    name: 'Egyéni színtanácsadás',
    metadata: {
      category: 'color',
      description: 'Igazi énidős program, ahol belemerülünk a színek világába',
      price: 60000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/color-rect.jpg',
      durationMinHours: 3/2,
      durationMaxHours: 2,
    }
  },
  {
    id: 'color-2',
    name: 'Páros színtanácsadás',
    metadata: {
      category: 'color',
      description: 'Osztozz a színtanácsadás élményén a szeretteiddel!',
      price: 50000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/color-2.jpg',
      durationMinHours: 3,
      durationMaxHours: 7/2,
      priceUnit: 'Fő'
    }
  },
  {
    id: 'color-multi',
    name: 'Csoportos színtanácsadás',
    metadata: {
      category: 'color',
      description: 'Álljatok össze 3-4-en, és csapjunk egy össznépi szín-bulit',
      price: 40000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/group.jpg',
      durationMinHours: 4,
      durationMaxHours: 5,
      priceUnit: 'Fő'
    }
  },
]

const bodyServices: Service[] = [
  {
    id: 'body',
    name: 'Egyéni testalkat tanácsadás',
    metadata: {
      category: 'body',
      description: 'Csak a te testi adottságaidat boncolgatjuk és keressük a számodra legideálisabb szabásvonalakat',
      price: 50000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/body.jpg',
      durationMinHours: 2,
      durationMaxHours: 5/2,
    }
  },
  {
    id: 'body-2',
    name: 'Páros testalkat tanácsadás',
    metadata: {
      category: 'body',
      description: 'Gyere el egy hozzád közel álló emberrel, és ismerjétek meg a testalkatotok sajátosságait',
      price: 40000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/body-2.jpg',
      durationMinHours: 5/2,
      durationMaxHours: 3,
      priceUnit: 'Fő'
    }
  },
  {
    id: 'body-multi',
    name: 'Csoportos testalkat tanácsadás',
    metadata: {
      category: 'body',
      description: 'Beszélj össze a családtagjaiddal vagy barátnőiddel, és nézzük meg, miben hasonlítotok, és miben különböztök',
      price: 30000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/body-group.jpg',
      durationMinHours: 4,
      durationMaxHours: 5,
      priceUnit: 'Fő'
    }
  },
]

const otherServices: Service[] = [
  {
    id: 'full',
    name: 'Teljes (szín- és testalkat) tanácsadás',
    metadata: {
      category: 'other',
      description: 'Ha minden esélyt meg akarsz adni magadnak a külső tujaldonságaid megismeréséhez',
      price: 95000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/full-fixed.jpg',
      durationMinHours: 4,
      durationMaxHours: 5,
    }
  },
  {
    id: 'wardrobe',
    name: 'Gardróbrendezés',
    metadata: {
      category: 'other',
      description: 'Ezer cuccod van, de semmi sem passzol össze? Megnézzük, mit lehet belőle kihozni!',
      price: 50000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/wardrobe-fixed.jpg',
      durationMinHours: 5/2,
      durationMaxHours: 3,
    }
  },
  {
    id: 'shopping',
    name: 'Közös vásárlás',
    metadata: {
      category: 'other',
      description: 'Utálsz vásárolni? Vagy épp ellenkezőleg, minden haszontalan cuccot megveszel? Segítek!',
      price: 45000,
      pictureUrl: 'https://storage.googleapis.com/simonadelstyle/shopping-fixed.jpg',
      durationMinHours: 5/2,
      durationMaxHours: 3,
    }
  },
]

export const services: {
  [serviceCategory in ServiceCategory]: {
    header: string
    services: Service[]
  }
} = {
  color: {
    header: 'Színtanácsadás',
    services: colorServices,
  },
  body: {
    header: 'Testalkat tanácsadás',
    services: bodyServices,
  },
  other: {
    header: 'Egyéb szolgáltatások',
    services: otherServices,
  },
}
